import { render, staticRenderFns } from "./BlogPostsFromCategory.vue?vue&type=template&id=1371234c&scoped=true&"
import script from "./BlogPostsFromCategory.vue?vue&type=script&lang=js&"
export * from "./BlogPostsFromCategory.vue?vue&type=script&lang=js&"
import style0 from "./BlogPostsFromCategory.vue?vue&type=style&index=0&id=1371234c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1371234c",
  null
  
)

export default component.exports